import { render, staticRenderFns } from "./editbom.vue?vue&type=template&id=0e837aea&scoped=true"
import script from "./editbom.vue?vue&type=script&lang=js"
export * from "./editbom.vue?vue&type=script&lang=js"
import style0 from "./editbom.vue?vue&type=style&index=0&id=0e837aea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e837aea",
  null
  
)

export default component.exports